import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";

import FullLoadingScreen from "../../../components/FullLoadingScreen";

import { EmailBlockedDialog } from "../../../components/EmailBlockedDialog";
import { IntegrationDisconnectedDialog } from "../../../components/IntegrationDisconnectedDialog";
import { PromotionDialog } from "../../../components/PromotionDialog";
import { USER_ROLES_ARRAY } from "../../../constants";
import { useAuth } from "../AuthContext";

const ProtectedRoute = ({ roles }) => {
	const { loggedIn, user } = useAuth();

	const [
		openIntegrationDisconnectedPopup,
		setOpenIntegrationDisconnectedPopup,
	] = useState(false);
	const [openEmailBlockedPopup, setOpenEmailBlockedPopup] = useState(false);

	useEffect(() => {
		if (
			user?.tele_disconnected ||
			user?.timo_disconnected ||
			user?.trans_disconnected
		) {
			setOpenIntegrationDisconnectedPopup(true);
		}

		if (user?.email_blocked) {
			setOpenEmailBlockedPopup(true);
		}
	}, [user]);

	if (loggedIn === null) {
		return <FullLoadingScreen />;
	}

	if (loggedIn === false) {
		return <Navigate to="/login" />;
	}

	if (roles && user && !roles.includes(user.role)) {
		if (user.role === "super-admin") {
			return <Navigate to="/admin" />;
		}
		if (USER_ROLES_ARRAY.includes(user.role)) {
			return <Navigate to="/" />;
		}
		return <Navigate to="/forbidden" />;
	}

	return (
		<>
			{/* SHOW IF INTEGRATION WITH TRANS IS DISCONNECTED */}
			<IntegrationDisconnectedDialog
				open={openIntegrationDisconnectedPopup}
				onClose={() => setOpenIntegrationDisconnectedPopup(false)}
				statuses={{
					trans: user?.trans_disconnected,
					timocom: user?.timo_disconnected,
					teleroute: user?.tele_disconnected,
				}}
			/>
			{/* SHOW IF SMTP NOT WORKING */}
			<EmailBlockedDialog
				open={openEmailBlockedPopup}
				onClose={() => setOpenEmailBlockedPopup(false)}
			/>
			<PromotionDialog />
			<Outlet />
		</>
	);
};

export default ProtectedRoute;
